export const cacheConfig = {
    typePolicies: {
        AdsManagerAdSet: {
            keyFields: ['db_id'],
        },
        // Query.AdAsset is an id-less namespace object shared by several queries (adAsset, adAssets, videoFrames);
        // without merging, each write replaces it and evicts the other queries' data, forcing refetch loops.
        AdAsset: {
            merge: true,
        },
        // Query.adHistoryStatus has no id and is read with two selections (the navigation asks only for `enabled`, the
        // page for the whole status); without merging, whichever lands second replaces the other.
        AdHistoryStatus: {
            merge: true,
        },
    },
}
